export default function ArrowLeftIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="19"
      fill="none"
      viewBox="0 0 11 19"
    >
      <path
        fill="#3E464F"
        d="m1.336 8.836 7.5-7.461c.351-.39.937-.39 1.328 0a.92.92 0 0 1 0 1.29L3.29 9.5l6.836 6.875c.39.352.39.938 0 1.29a.856.856 0 0 1-1.29 0l-7.5-7.5c-.39-.352-.39-.938 0-1.33Z"
      />
    </svg>
  )
}
